const NULLREG = '^[sS]*.*[^s][sS]*$'
const MOBILEREG = '^1.{7,}$'
const SEX_NULL_REG = '^[^0]$'
const TYPE_NULL_REG = '^[1-9]\\d*|0$'
const EMAIL_REG = '^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$'
const PASSWORD_REG = '^(?![a-z]+$)(?![A-Z]+$)(?![\\_]+$)(?![\\d]+$)[a-zA-Z\\d_\\_]{6,}$';
const NICK_REG = '^[a-zA-Z][a-zA-Z0-9_]{6,30}$';
const PASSENGER_NAME_REG = '^.{0,30}$';

const cardType = {
  //身份证
  idCard: '1',
  //护照
  passport: 'B',
  //港澳台居民居住证
  HKMCTWResidence: '2',
  //台湾居民来往大陆通行证
  taibaoCard: 'G',
  //军官证
  officerCard: '5',
  //回乡证，废弃
  reentryCard: '6',
  //外国人永久居留身份证
  foreignerCard: 'H',
  //港澳居民来往内地通行证 貌似就是回乡证
  exitEntryHKMCTWCard: 'C',
  //公务护照
  officialPassport: '9',
  //外交护照
  diplomacyPassport: '10',
  other: '11',
}

export const commonConfig = {
    passenger_name: {
      //中文名
      isShow: true,
      isRequired: true,
      requiredcCrdTypes: [],
      tips: '姓名需在30位字符以内',
      validator: PASSENGER_NAME_REG,
      toastNullTips:'姓名不能为空',
      toastTips:'姓名需在30位字符以内'
    },
    card_type: {
      //证件类型
      isShow: true,
      isRequired: true,
      requiredcCrdTypes: [],
      tips: '',
      validator: NULLREG,
    },
    encrypt_phone: {
      //手机号码
      isShow: true,
      isRequired: true,
      requiredcCrdTypes: [],
      tips: '请输入有效的手机号码',
      validator: MOBILEREG,
      toastNullTips:'手机号码不能为空',
      toastTips:'手机号码格式错误 '
    },
    id_no: {
      //证件号
      isShow: true,
      isRequired: true,
      requiredcCrdTypes: [],
      tips: '请输入正确的证件号码',
      validator: NULLREG,
      toastNullTips:'证件号码不能为空',
      toastTips:'请输入正确的证件号码 '
    },
    expire_date: {
      //证件号有效期
      isShow: false,
      isRequired: false,
      requiredcCrdTypes: [],
      tips: '请选择证件有效期',
      validator: NULLREG
    },
    born_date: {
      //出生日期
      isShow: false,
      isRequired: false,
      // 除身份证外的其他证件，出生日期必填
      requiredcCrdTypes: [
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11'
      ],
      tips: '请选择出生日期',
      validator: NULLREG,
      toastNullTips:'请选择出生日期',
      toastTips:' 请选择出生日期'
    },
    sex: {
      //性别
      isShow: false,
      isRequired: false,
      // 台胞证、回乡证、往来港澳通行证，性别必填
      // requiredcCrdTypes:['4', '6', '8'],
      requiredcCrdTypes: [],
      tips: '请选择性别',
      validator: SEX_NULL_REG,
      toastNullTips:'请选择性别',
      toastTips:'请选择性别'

    },
    nickname: {
      isShow: true,
      isRequired: true,
      requiredcCrdTypes: [],
      tips: '字母开头,只能包含字母,数字,"_",6-30位',
      validator: NICK_REG,
      toastNullTips:'用户名不能为空',
      toastTips:'用户名格式错误'
    },
    nationlity: {
      isShow: false,
      isRequired: false,
      requiredcCrdTypes: [],
      tips: '请选择国籍',
      validator: function(obj, msg) {
        if (!obj || !obj.country_code) {
          return msg;
        }
      },
      toastNullTips:'国籍不能为空',
      toastTips:'国籍不能为空'
    },
    password: {
      isShow: true,
      isRequired: true,
      requiredcCrdTypes: [],
      tips: '字母、数字、下划线中至少包含两种，不少于6位',
      validator: PASSWORD_REG,
      toastNullTips:'密码不能为空',
      toastTips:'密码格式错误'
    },
    confirm_password: {
      isShow: true,
      isRequired: true,
      requiredcCrdTypes: [],
      tips: '字母、数字、下划线中至少包含两种，不少于6位',
      validator: PASSWORD_REG,
      toastNullTips:'确认密码不能为空',
      toastTips:'确认密码格式错误'
    },
    email: {
      isShow: true,
      isRequired: false,
      requiredcCrdTypes: [],
      tips: '请输入正确的邮箱格式',
      validator: EMAIL_REG,
      toastTips:'邮箱格式格式错误'
    },
  };
//12306注册配置
export const registerConfig = {
  ...commonConfig,
  expire_date: {
    //证件号有效期
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [
      cardType.passport,
      cardType.foreignerCard,
      cardType.taibaoCard,
      cardType.reentryCard,
      cardType.exitEntryHKMCTWCard
    ],
    tips: '请选择证件有效期',
    validator: NULLREG
  },
  born_date: {
    //出生日期
    isShow: false,
    isRequired: false,
    // 除身份证外的其他证件，出生日期必填
    requiredcCrdTypes: [
      cardType.passport,
      cardType.foreignerCard,
      cardType.taibaoCard,
      cardType.reentryCard,
      cardType.exitEntryHKMCTWCard
    ],
    tips: '请选择出生日期',
    validator: NULLREG
  },
  sex: {
    //性别
    isShow: false,
    isRequired: false,
    requiredcCrdTypes: [
      // cardType.idCard,
      // cardType.HKMCTWResidence,
      cardType.passport,
      cardType.exitEntryHKMCTWCard,
      cardType.taibaoCard,
      cardType.foreignerCard
    ],
    tips: '请选择性别',
    toastNullTips:'请选择性别',
    toastTips:'请选择性别',
    validator: SEX_NULL_REG
  },
  nationlity: {
    ...commonConfig.nationlity,
    isShow: false,
    requiredcCrdTypes: [cardType.passport],
    isRequired: false,
    tips: '请选择国籍',
    validator: function(obj, msg) {
      if (!obj || !obj.country_code) {
        return msg;
      }
    }
  }
};

export const componentsConfig = {
  passenger_name: 'es-contact-name',
  english_surname: 'es-english-surname',
  english_name: 'es-english-name',
  passenger_type: 'es-contact-type',
  encrypt_phone: 'es-contact-phone',
  born_date: 'es-birth-date',
  expire_date: 'es-expire-date',
  sex: 'es-contact-sex',
  nickname: 'es-contact-nickname12306',
  remark: 'es-contact-remark',
  nationlity: 'es-nationlity',
  password: 'es-password',
  confirm_password: 'es-confirm-password',
  email: 'es-email',
  id_no:'es-id-no',
  card_type:'es-card-type'
};

